import { render, staticRenderFns } from "./VoucerService.vue?vue&type=template&id=0454b13a&"
import script from "./VoucerService.vue?vue&type=script&lang=js&"
export * from "./VoucerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports